<template>
    <div>
        <div class="flex items-center justify-center flex-wrap">
            <Card class="card-stats" style="background-color:#00bcd4;" :bordered="false">
                <div class="card-content">
                    <p class="vue-card-title">
                        <Icon type="md-git-network"/>
                        Projeto(Tipo)
                    </p>
                    <h4 class="card-number">{{ projetos.length }}</h4>
                </div>
                <div class="card-action">
                    <span v-for="(item, key) in qtde_tipo" :key="key" style="margin:0 2px; cursor:pointer;">
                        <Tooltip :content="item.nome" placement="top">

                            <Icon class="transition"
                                  :type="item.icone"
                                  @click="disableBrothersFilters(qtde_tipo, key);"
                                  :size="filters[key] ? '30' : '19'"
                                  :style="{color:(filters[key] ? '#fff' : '#EEE0E5'), lineHeight:'20px'}"
                            />: {{ quantidadesProjetos[key] }}

                        </Tooltip>
                    </span>
                </div>
            </Card>
            <Card class="card-stats" style="background-color:#00bfa5;" :bordered="false">
                <div class="card-content">
                    <p class="vue-card-title">
                        <Icon type="md-git-branch"/>
                        MVP
                    </p>
                    <h4 class="card-number">{{ qtde_mvps }}</h4>
                </div>
                <div class="card-action">
                    <span v-for="(item, key) in situacao" :key="key" style="margin:0 2px; cursor:pointer;">
                        <Tooltip :content="item.nome" placement="top">
                            <Icon class="transition" :type="item.icone" @click="filters[key] = !filters[key]" :size="filters[key] ? '30' : '19'" :style="{color:(filters[key] ? '#fff' : '#EEE0E5'), lineHeight:'20px'}"/>: {{ quantidadesProjetos[key] }}
                        </Tooltip>
                    </span>
                </div>
            </Card>
            <Card class="card-stats" style="background-color:#ff5252;" :bordered="false">
                <div class="card-content">
                    <p class="vue-card-title">
                        <Icon type="md-git-network"/>
                        Projeto(Andamento)
                    </p>
                    <h4 class="card-number">{{ projetos.length }}</h4>
                </div>
                <div class="card-action">
                    <span v-for="(item, key) in andamento_projetos" :key="key" style="margin:0 2px; cursor:pointer;">
                        <Tooltip :content="item.nome" placement="top"><Icon class="transition" :type="item.icone" @click="disableBrothersFilters(andamento_projetos, key)" :size="filters[key] ? '30' : '19'" :style="{color:(filters[key] ? '#fff' : '#EEE0E5'), lineHeight:'20px'}"/>: {{ quantidadesProjetos[key] }}</Tooltip>
                    </span>
                </div>
            </Card>
            <Card class="card-stats" v-show="false" style="background-color:#ff5252;" :bordered="false">
                <div class="card-content">
                    <p class="vue-card-title">
                        <Icon type="md-git-merge"/>
                        Tipo
                    </p>
                    <p v-for="(item, nome) in qtde_tipo" :key="nome"><b>{{ nome }}:</b> {{ item.total }}, Em dia: {{
                        item.total }}, Atrasado: {{ item.total }} </p>
                </div>
                <div class="card-action"></div>
            </Card>
        </div>
        <DrawerTicket v-model="edit_mvp.active" :id="edit_mvp.id" :id_projeto="edit_mvp.id_projeto" @update="onTicketUpdate"></DrawerTicket>
        <div class="table-draggable">
            <div class="table-header-row">
                <div v-for="(column, index) in columns" :key=index :style="{ width: (column.width || '100%') }"
                     class="column">
                    <div class="table-cell-inner">{{ column.title ? column.title : '' }}</div>
                </div>
            </div>
            <Container @drop="onDrop" lock-axis="y" drag-handle-selector=".drag-selector">
                <Draggable v-for="(projeto, p_idx) in projetos_filter" :key="projeto.id_projeto">
                    <div class="table-row">
                        <div v-for="(column, index) in columns" :key=index :style="{ width: (column.width || '100%') }"
                             class="column table-cel" :class="{'drag-selector': enableDrag}">
                            <a v-if="column.type =='expand'" class="table-cell-with-expand" @click="expandir(p_idx)">
                                <Icon v-if="!projeto.expanded" type="ios-arrow-forward"/>
                                <Icon v-if="projeto.expanded" type="ios-arrow-down"/>
                            </a>
                            <div v-else class="table-cell-inner">
                                <custom-render
                                        v-if="column.render"
                                        :row="projeto"
                                        :column="column"
                                        :index="index"
                                        :render="column.render"></custom-render>
                                {{ !column.render ? projeto[column.key] : '' }}
                            </div>
                        </div>
                    </div>
                    <div v-if="projeto.expanded" :style="{ width: '100%' }" class="table-row table-row-expanded">
                        <custom-render
                                :row="projeto"
                                :column="columns[0]"
                                :index="0"
                                :render="columns[0].render"></custom-render>
                    </div>
                </Draggable>
            </Container>
        </div>
        <div class="floating-btn">
<!--            <router-link to="/projeto">-->
<!--                <i-button type="primary" shape="circle" icon="md-add"></i-button>-->
<!--            </router-link>-->
            <i-button @click="newProject" type="primary" shape="circle" icon="md-add"></i-button>
        </div>
        <drawer
                placement="right"
                title="Projeto"
                v-model="edit_project.active"
                :width="widthDrawer">
            <projeto :id="edit_project.id" v-if="edit_project.active" hideMvps @update="onUpdate"></projeto>
        </drawer>
    </div>

</template>

<script>
    const accounting = require("accounting");
    const {moment} = require("../../helpers/utils.js");
    import debounce from "lodash/debounce"
    export default {
        components: {
            DrawerTicket: () => import("../tickets/components/Drawer.vue"),
            Projeto: () => import('./Projeto.vue'),
            Container: () =>
                import("vue-smooth-dnd").then(({Container}) => Container),
            Draggable: () =>
                import("vue-smooth-dnd").then(({Draggable}) => Draggable),
        },
        name: "projetos",
        data() {
            return {
                enableDrag: true,
                widthDrawer: 850,
                edit_project: {
                    active: false,
                    id: 0
                },
                edit_mvp: {
                    active: false,
                    id: 0
                },
                edit_pgd:false,
                edit_id:0,
                qtde_mvps: 0,
                qtde_tipo: [],
                tipos_projeto: [],
                andamento_projetos: [],
                quantidadesProjetosAnterior:{},
                filters: {
                    atrasado:false,
                    naoatrasado:false,
                    resolvido:false,
                    deploy:false,
                    testes:false,
                    desenvolvimento:false,
                    atribuido:false,
                    quarentena:false,
                    evolucaoInterna:false,
                    demandaLegal:false,
                    inovacaoCliente:false,
                    expansaoComercial:false,
                    seguranca:false
                },
                situacao: {
                    quarentena: {
                        nome: "Quarentena",
                        icone: "ios-snow",
                        total: 0
                    },
                    atribuido: {
                        nome: "Atribuído",
                        icone: "ios-sunny",
                        total: 0
                    },
                    desenvolvimento: {
                        nome: "Desenvolvimento",
                        icone: "ios-settings",
                        total: 0
                    },
                    testes: {
                        nome: "Testes",
                        icone: "ios-eye",
                        total: 0
                    },
                    deploy: {
                        nome: "Deploy",
                        icone: "ios-cloud-done",
                        total: 0
                    }
                },
                columns: [
                    {
                        type: "expand",
                        width: "5%",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "Card",
                                    {
                                        props: {"dis-hover": true},
                                        style: {
                                            marginBottom: "20px"
                                        }
                                    },
                                    [
                                        h(
                                            "Divider",
                                            {props: {orientation: "left"}},
                                            "Resumo"
                                        ),
                                        params.row.resumo
                                    ]
                                ),
                                h(
                                    "Card",
                                    {
                                        props: {"dis-hover": true},
                                        style: {
                                            marginBottom: "20px"
                                        }
                                    },
                                    [
                                        h(
                                            "Divider",
                                            {props: {orientation: "left"}},
                                            "Projeto details"
                                        ),
                                        h({
                                            template: `<div>${
                                                params.row.descricao_detalhada
                                                }</div>`
                                        })
                                    ]
                                ),
                                h(
                                    "Card",
                                    {
                                        attrs: {
                                            class: 'table-mvps'
                                        },
                                        props: {"dis-hover": true},
                                        style: {
                                            marginBottom: "20px"
                                        }
                                    },
                                    [
                                        h(
                                            "Divider",
                                            {
                                                props: {orientation: "left"},
                                                style: {position: "relative"}
                                            },
                                            [
                                                "MVP",
                                                h(
                                                    "Button",
                                                    {
                                                        attrs: {
                                                            class:"add-mvp"
                                                        },
                                                        props: {
                                                            icon: "ios-add",
                                                            type: "primary",
                                                            shape: "circle",
                                                            size: "large"
                                                        },
                                                        style: {position: "absolute", right:"10px", top: "-4px", zIndex: "1"},
                                                        on: {
                                                            click: () =>
                                                                this.newMvp(
                                                                    params.row.id_projeto
                                                                )
                                                        }
                                                    }
                                                )
                                            ]
                                        ),
                                        h("TableDraggable", {
                                            attrs: {
                                                columns: [
                                                    {
                                                        title:"#",
                                                        key:"id_ticket",
                                                        width:80
                                                    },
                                                    {
                                                        title: "Resumo",
                                                        key: "resumo",
                                                        render: (h, params) => {
                                                            return h(
                                                                "div",
                                                                {
                                                                    style: {
                                                                        fontSize: "16px"
                                                                    }
                                                                },
                                                                [
                                                                    h(
                                                                        "a",
                                                                        {
                                                                            attrs: {
                                                                                class: "table-edit"
                                                                            },
                                                                            on: {
                                                                                click: () =>
                                                                                    this.editTicket(
                                                                                        params.row.id_ticket
                                                                                    )
                                                                            }
                                                                        },
                                                                        [
                                                                            params.row.resumo,
                                                                            h("Icon", {
                                                                                props: {
                                                                                    type: "md-create"
                                                                                }
                                                                            })
                                                                        ]
                                                                    )
                                                                ]
                                                            );
                                                        }
                                                    },
                                                    {
                                                        title: "Atribuído a",
                                                        key: "atribuido_a_nome",
                                                        width: 120,
                                                        render: (h, params) => {
                                                            return h(
                                                                "span",
                                                                params.row.atribuido_a_nome
                                                                    ? params.row.atribuido_a_nome.replace(/ .*/, "")
                                                                    : ""
                                                            );
                                                        }
                                                    },
                                                    {
                                                        title: "Andamento",
                                                        key: "andamento",
                                                        width:220,
                                                        render: (h, params) => {
                                                            return h(
                                                                "PgdAndamento",
                                                                {
                                                                    props: {
                                                                        andamento:
                                                                            params
                                                                                .row
                                                                                .andamento ||
                                                                            0
                                                                    }
                                                                }
                                                            );
                                                        }
                                                    },
                                                    {
                                                        title: " ",
                                                        key: "delete",
                                                        width:80,
                                                        render: (h, params) => {
                                                            return h(
                                                                "vs-button",
                                                                {
                                                                    props: {
                                                                        icon: 'icon-trash',
                                                                        iconPack: 'feather',
                                                                        size: 'small',
                                                                        radius: true,
                                                                        type: 'border',
                                                                        color: 'danger'
                                                                    },
                                                                    on: {
                                                                        click: () => {
                                                                            this.inactivateMvp(params.row)
                                                                        }
                                                                    }
                                                                }
                                                            );
                                                        }
                                                    }
                                                ],
                                                dataItems: params.row.mvps
                                            },
                                            on: {
                                                drop: (p) =>
                                                    this.onDropMvps(p, params.row.id_projeto)
                                            }
                                        })
                                    ]
                                )
                            ]);
                        }
                    },
                    {
                        title: "",
                        key: "posicao",
                        width: "5%",
                        render: (h, params) => {
                            return h("Tag", params.row.posicao);
                        }
                    },
                    {
                        title: "Projeto",
                        key: "nome",
                        width: "40%",
                        sortable: true,
                        render: (h, params) => {
                            return h("h1", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            class: "table-edit"
                                        },
                                        on: {
                                            click: () =>
                                                this.editProject(
                                                    params.row.id_projeto
                                                )
                                        }
                                    },
                                    [
                                        `(${params.row.id_projeto}) ${params.row.nome}`,
                                        h("Icon", {
                                            props: {
                                                type: "md-create"
                                            }
                                        })
                                    ]
                                )
                            ]);
                        }
                    },
                    {
                        title: "Tipo",
                        key: "tipo_projeto_nome",
                        width: "15%"
                    },
                    {
                        title: "Progresso",
                        width: "10%",
                        render: (h, params) => {
                            let percent = params.row.percentual;
                            if (percent == 100) {
                                return h(
                                    "i-circle",
                                    {
                                        attrs: {
                                            percent,
                                            strokeColor: "#5cb85c",
                                            size: 70
                                        }
                                    },
                                    [
                                        h(
                                            "Icon",
                                            {
                                                props: {
                                                    type: "ios-checkmark"
                                                },
                                                style: {
                                                    color: "#5cb85c",
                                                    fontSize: "60px"
                                                }
                                            },
                                            `100%`
                                        )
                                    ]
                                );
                            } else {
                                return h(
                                    "i-circle",
                                    {
                                        attrs: {
                                            percent,
                                            size: 70
                                        }
                                    },
                                    [
                                        h("h1", `${accounting.formatNumber(percent, 1, ".", ",") || 0}%`),
                                        h("p", `${params.row.mvps_resolvidos}/${params.row.total_mvps}`)
                                    ]
                                );
                            }
                        }
                    }
                ],
                projetos: [],
            };
        },
        computed: {
            projetos_filter() {
                let projetos = this.projetos;
                if (this.filters.resolvido) { //story resolvidos
                    projetos =  projetos.filter(projeto => projeto.mvps_resolvidos == projeto.total_mvps);
                } if (this.filters.naoatrasado) { //não atrasados
                    projetos = projetos.filter(pj => !pj.atrasado && pj.mvps_resolvidos != pj.total_mvps);
                } if (this.filters.atrasado) { //atrasado
                    projetos = projetos.filter(pj => pj.atrasado);
                } if(this.filters.deploy) { //deploy
                    projetos = projetos.filter(pj => (pj.mvps.filter(mvp => mvp.status == 2 && mvp.andamento > 6).length > 0));
                } if (this.filters.desenvolvimento) {
                    projetos = projetos.filter(pj => (pj.mvps.filter(mvp=> mvp.andamento == 2 && mvp.status == 1).length >0));
                } if (this.filters.testes) {
                    projetos = projetos.filter(pj => (pj.mvps.filter(mvp=> [4].includes(mvp.andamento) && mvp.status == 1)).length >0);
                } if (this.filters.atribuido) {
                    projetos = projetos.filter(pj => (pj.mvps.filter(mvp=> mvp.andamento == 0 && mvp.status == 1)).length >0);
                } if (this.filters.quarentena) {
                    projetos = projetos.filter(pj => (pj.mvps.filter(mvp=> mvp.status == 0).length >0));
                } if (this.filters.demandaLegal) {
                    projetos = projetos.filter(pj => pj.tipo_projeto_id == 38);
                } if (this.filters.seguranca) {
                    projetos = projetos.filter(pj => pj.tipo_projeto_id == 37);
                } if (this.filters.inovacaoCliente) {
                    projetos = projetos.filter(pj => pj.tipo_projeto_id == 42);
                } if (this.filters.evolucaoInterna) {
                    projetos = projetos.filter(pj => pj.tipo_projeto_id == 43);
                } if (this.filters.expansaoComercial) {
                    projetos = projetos.filter(pj => pj.tipo_projeto_id == 44);
                }
                return projetos;
            },
            widthCel() {
                return `${90 / (this.columns.length - 2)}%`;
            },
            quantidadesProjetos(){
                let tiposProjeto = [this.filters.demandaLegal, this.filters.evolucaoInterna, this.filters.inovacaoCliente, this.filters.expansaoComercial, this.filters.seguranca].includes(true);
                let mvps = [this.filters.deploy, this.filters.testes, this.filters.desenvolvimento, this.filters.atribuido, this.filters.quarentena].includes(true);
                let projetoAndamento = [this.filters.atrasado, this.filters.naoatrasado, this.filters.resolvido].includes(true);
                let quantidades = {
                    atrasado:projetoAndamento ? this.quantidadesProjetosAnterior.atrasado : this.projetos_filter.filter(pj => pj.atrasado).length,
                    naoatrasado:projetoAndamento ? this.quantidadesProjetosAnterior.naoatrasado : this.projetos_filter.filter(pj => !pj.atrasado && pj.mvps_resolvidos != pj.total_mvps).length,
                    resolvido:projetoAndamento ? this.quantidadesProjetosAnterior.resolvido : this.projetos_filter.filter(projeto => projeto.mvps_resolvidos == projeto.total_mvps).length,
                    deploy:mvps ? this.quantidadesProjetosAnterior.deploy : this.projetos_filter.reduce((a, pj) => a = a + pj.mvps.filter(mvp => mvp.status == 2 && mvp.andamento > 6).length, 0),
                    testes:mvps ? this.quantidadesProjetosAnterior.testes : this.projetos_filter.reduce((a, pj) => a + pj.mvps.filter(mvp=> [4].includes(mvp.andamento) && mvp.status == 1).length, 0),
                    desenvolvimento:mvps ? this.quantidadesProjetosAnterior.desenvolvimento : this.projetos_filter.reduce((a,pj) => a + pj.mvps.filter(mvp=> mvp.andamento == 2 && mvp.status == 1).length, 0),
                    atribuido:mvps ? this.quantidadesProjetosAnterior.atribuido : this.projetos_filter.reduce((a, pj) => a + pj.mvps.filter(mvp=> mvp.andamento == 0 && mvp.status == 1).length, 0),
                    quarentena:mvps ? this.quantidadesProjetosAnterior.quarentena : this.projetos_filter.reduce((a, pj) => a + pj.mvps.filter(mvp=> mvp.status == 0).length, 0),
                    evolucaoInterna:tiposProjeto ? this.quantidadesProjetosAnterior.evolucaoInterna : this.projetos_filter.filter(pj => pj.tipo_projeto_id == 43).length,
                    demandaLegal:tiposProjeto ? this.quantidadesProjetosAnterior.demandaLegal : this.projetos_filter.filter(pj => pj.tipo_projeto_id == 38).length,
                    inovacaoCliente:tiposProjeto ? this.quantidadesProjetosAnterior.inovacaoCliente : this.projetos_filter.filter(pj => pj.tipo_projeto_id == 42).length,
                    expansaoComercial:tiposProjeto ? this.quantidadesProjetosAnterior.expansaoComercial : this.projetos_filter.filter(pj => pj.tipo_projeto_id == 44).length,
                    seguranca:tiposProjeto ? this.quantidadesProjetosAnterior.seguranca : this.projetos_filter.filter(pj => pj.tipo_projeto_id == 37).length
                }
                this.quantidadesProjetosAnterior = quantidades;
                return quantidades;
            },
            quantidadeTotalPainel(){
                return {
                    tiposProjetos:  [this.filters.demandaLegal, this.filters.evolucaoInterna, this.filters.inovacaoCliente, this.filters.expansaoComercial, this.filters.seguranca].includes(true) ? this.projetos.length :
                                    this.quantidadesProjetos.demandaLegal + this.quantidadesProjetos.expansaoComercial + this.quantidadesProjetos.seguranca + this.quantidadesProjetos.inovacaoCliente + this.quantidadesProjetos.evolucaoInterna,
                    mvps: [this.filters.deploy, this.filters.testes, this.filters.desenvolvimento, this.filters.atribuido, this.filters.quarentena].includes(true) ? this.qtde_mvps : this.quantidadesProjetos.deploy + this.quantidadesProjetos.testes + this.quantidadesProjetos.desenvolvimento + this.quantidadesProjetos.atribuido + this.quantidadesProjetos.quarentena,
                    projetoAndamento:[this.filters.atrasado, this.filters.naoatrasado, this.filters.resolvido].includes(true) ? this.projetos.length : this.quantidadesProjetos.atrasado + this.quantidadesProjetos.naoatrasado + this.quantidadesProjetos.resolvido
                }
            },
        },
        created() {
            this.$Spin.show();
            this.getTiposProjeto();
            this.getProjetos();
        },
        methods: {
            /**
             * Detalha as informações do projeto selecionado,
             * expandindo a linha, exibindo informações detalhadas
             */
            expandir(index) {
                this.projetos_filter[index].expanded = !this.projetos_filter[index].expanded;
            },
            async getTiposProjeto() {
                try {
                    const URI = `parametro/tiposProjeto`;
                    let {data} = await this.$axios.get(URI);

                    /**
                     * Cria um array de objetos relacionando id como chave para o nome
                     */
                    this.tipos_projeto = data.reduce((list, item) => {
                        list[item.id_parametro] = item;
                        return list;
                    }, {});
                } catch (error) {
                    console.warn(error);
                }
            },
            tiposProjetos(projetos) {
                /**
                 * Soma a quantidade de projetos por tipo
                 */
                this.getTiposProjeto();
                const totais = {demandaLegal:0, evolucaoInterna:0, expansaoComercial:0, inovacaoCliente:0, seguranca:0};
                this.projetos.filter(projeto =>{
                    if(projeto.tipo_projeto_id == 37){
                        totais.seguranca += 1;
                    }else if(projeto.tipo_projeto_id == 38){
                        totais.demandaLegal += 1;
                    }else if(projeto.tipo_projeto_id == 42){
                        totais.inovacaoCliente += 1;
                    }else if(projeto.tipo_projeto_id == 43){
                        totais.evolucaoInterna += 1;
                    }else if(projeto.tipo_projeto_id == 44){
                        totais.expansaoComercial += 1;
                    }
                })
                this.qtde_tipo = {
                    demandaLegal:{
                        icone:"ios-pulse",
                        total:totais.demandaLegal,
                        nome:'Demanda Legal'
                    },
                    evolucaoInterna:{
                        icone:"ios-infinite",
                        total:totais.evolucaoInterna,
                        nome:'Evolução Interna'
                    },
                    expansaoComercial:{
                        icone:"ios-trending-up",
                        total:totais.expansaoComercial,
                        nome:'Expansão Comercial'
                    },
                    inovacaoCliente:{
                        icone:"ios-bulb",
                        total:totais.inovacaoCliente,
                        nome:'Inovação para Cliente'
                    },
                    seguranca:{
                        icone:"ios-lock",
                        total:totais.seguranca,
                        nome:'Segurança'
                    }
                }
            },
            situacaoMvps(arr) {
                /**
                 * Soma a quantidade de story por status
                 */
                for (const situacao of arr) {
                    if (situacao.status == 0) {
                        this.situacao.quarentena.total += 1;
                    } else if (situacao.status == 1) {
                        if (situacao.andamento == 0) {
                            this.situacao.atribuido.total += 1;
                        } else if ([1,2].includes(situacao.andamento)) {
                            this.situacao.desenvolvimento.total += 1;
                        } else if ([3].includes(situacao.andamento)) {
                            this.situacao.testes.total += 1;
                        }
                    } else if (situacao.status == 2 && situacao.andamento >= 6) {
                        this.situacao.deploy.total += 1;
                    }
                }
            },
            andamentoProjetos(projetos) {
                const atrasados = this.projetos_filter.filter(proj => proj.atrasado).length;
                const projetos_resolvidos = this.projetos_filter.filter(projeto => projeto.mvps_resolvidos == projeto.total_mvps).length;
                this.andamento_projetos = {
                    atrasado : {
                        nome: "Atrasado",
                        icone: "md-time",
                        total: atrasados,
                    },
                    naoatrasado: {
                        nome: "Não atrasado",
                        icone: "md-timer",
                        total: projetos.length - atrasados - projetos_resolvidos,
                    },
                    resolvido: {
                        nome:"Concluídos",
                        icone:"md-alarm",
                        total:projetos_resolvidos,
                    }
                };
            },
            /**
             * Faz a consulta dos projetos
             */
            async getProjetos() {
                try {
                    const URI = `projeto`;
                    let {data} = await this.$axios.get(URI);
                    let lista_status = [];
                    const projetos = data.map(projeto => {
                        /**
                         * Array de Projetos para criar a quantidade de projetos por tipo
                         */
                        projeto.expanded = false;
                        /**
                         * Ordena os MVP pelo peso calculado
                         */
                        projeto.mvps = projeto.mvps.filter(mvp => mvp.ativo == 1).map(mvp => {
                                /**
                                 * Array de andamento de todos os story
                                 */
                                lista_status.push({
                                    status: mvp.status,
                                    andamento: mvp.andamento
                                });
                                return mvp;
                            })
                            .sort((a, b) => {
                                if (a.posicao > b.posicao) {
                                    return 1;
                                }
                                if (a.posicao < b.posicao) {
                                    return -1;
                                }
                                return 0;
                            });
                        /**
                         * Atributos para saber o andamento do projeto e o percentual de MVPs finalizados
                         **/
                        projeto.mvps_resolvidos = projeto.mvps.filter(
                            mvp => mvp.andamento == 7 || mvp.status == 2
                        ).length;

                        projeto.total_mvps = projeto.mvps.length;
                        this.qtde_mvps += projeto.total_mvps;
                        projeto.percentual =
                            (projeto.mvps_resolvidos * 100) / projeto.total_mvps;

                        /**
                         * Atributo para saber se o projeto está atrasado (true/false)
                         */
                        projeto.atrasado =
                            moment(moment()).isAfter(new Date(projeto.prazo_termino)) &&
                            projeto.mvps_resolvidos != projeto.total_mvps;
                        return projeto;
                    }, this);
                    this.projetos = projetos;
                    this.tiposProjetos(projetos);
                    this.situacaoMvps(lista_status);
                    this.andamentoProjetos(projetos);

                    this.$Spin.hide();
                } catch (ex) {
                    console.warn(ex);
                    this.$Spin.hide();
                }
            },
            /**
             * Método que permite reordenar os projetos de acordo com o arraste
             */
            onDrop({removedIndex, addedIndex, payload}) {
                const arr = this.projetos;
                if (removedIndex === null || addedIndex === null) return;
                let result = [...arr];
                let itemToAdd = payload;
                removedIndex = result.findIndex(pj => pj.id_projeto == this.projetos_filter[removedIndex].id_projeto);
                addedIndex = result.findIndex(pj => pj.id_projeto == this.projetos_filter[addedIndex].id_projeto);
                itemToAdd = result.splice(removedIndex, 1)[0];
                /**
                 * Atualiza a posição dos projetos no Banco de Dados
                 */
                const id_projeto = itemToAdd.id_projeto;
                const pos_atual = parseInt(itemToAdd.posicao);
                const pos_nova = parseInt(arr[addedIndex].posicao);
                this.atualizarPosicaoDB(id_projeto, pos_nova, pos_atual);
                result = this.atualizarPosicao(result, pos_nova, pos_atual);
                itemToAdd.posicao = pos_nova;
                result.splice(addedIndex, 0, itemToAdd);
                this.projetos = result;
            },
            onDropMvps({removedIndex, addedIndex}, id_projeto) {
                if (removedIndex === null || addedIndex === null) return;
                const idxProj = this.projetos.findIndex(proj => proj.id_projeto === id_projeto);

                const arr = this.projetos[idxProj].mvps;
                let result = [...arr];

                const itemToAdd = arr[removedIndex];
                const {id_ticket} = itemToAdd;
                const pos_atual = parseInt(itemToAdd.posicao);
                const pos_nova = parseInt(arr[addedIndex].posicao);
                result = this.atualizarPosicao(result, pos_nova, pos_atual);
                this.atualizarPosicaoMvpDB(id_ticket, pos_nova, pos_atual);

                result.splice(removedIndex, 1);
                itemToAdd.posicao = pos_nova;
                result.splice(addedIndex, 0, itemToAdd);

                this.projetos[idxProj].mvps = result;

            },
            atualizarPosicao(arr, pos_nova, pos_atual) {
                return arr.map(item => {
                    if (pos_nova > pos_atual) {
                        item.posicao -=
                            item.posicao > pos_atual && item.posicao <= pos_nova
                                ? 1
                                : 0;
                    } else {
                        item.posicao +=
                            item.posicao < pos_atual && item.posicao >= pos_nova
                                ? 1
                                : 0;
                    }
                    return item;
                });
            },
            async atualizarPosicaoDB(id_projeto, pos_nova, pos_atual) {
                try {
                    await this.$axios.put(`projeto/${id_projeto}/atualizarPosicao`, {
                        pos_nova,
                        pos_atual
                    });
                } catch (error) {
                    console.warn(error);
                    this.getProjetos();
                }
            },
            async atualizarPosicaoMvpDB(id_ticket, pos_nova, pos_atual) {
                try {
                    await this.$axios.put(`ticket/${id_ticket}/atualizarPosicao`, {
                        pos_nova,
                        pos_atual
                    });
                } catch (error) {
                    console.warn(error);
                    this.getProjetos();
                }
            },
            newProject() {
                this.edit_project.id = 0;
                this.edit_project.active = true;
            },
            editProject(id) {
                this.edit_project.id = id;
                this.edit_project.active = true;
            },
            onUpdate(projeto) {
                const idxProj = this.projetos.findIndex(proj => proj.id_projeto === projeto.id_projeto);

                if (idxProj > -1) {
                    this.projetos.splice(idxProj, 1, {
                        ...this.projetos[idxProj],
                        ...projeto});
                } else {
                    this.edit_project.active = false;
                    this.projetos.push({
                        ...projeto,
                        expanded: false,
                        mvps_resolvidos: 0,
                        total_mvps: 0,
                        atrasado: 0
                    });
                }

                this.$forceUpdate();
            },
            editTicket(id_ticket) {
                this.edit_mvp.id = id_ticket;
                this.edit_mvp.id_projeto = 0;
                this.edit_mvp.active = true;
            },
            newMvp(id_projeto) {
                this.edit_mvp.id = 0;
                this.edit_mvp.id_projeto = id_projeto;
                this.edit_mvp.active = true;
            },
            inactivateMvp({projeto_id, id_ticket}) {
                const idxProj = this.projetos.findIndex(proj => proj.id_projeto === projeto_id);
                const idxMvp = this.projetos[idxProj].mvps.findIndex(mvp => mvp.id_ticket === id_ticket);
                
                this.$Modal.confirm({
                    title: `Remover MVP ${id_ticket}`,
                    content: 'Deseja realmente remover?',
                    cancelText: "Não",
                    okText: "Sim",
                    onOk: () => {
                        this.$axios.put(`ticket/${id_ticket}`, {
                            ativo: 0
                        });
                        this.projetos[idxProj].mvps.splice(idxMvp, 1);
                        this.$forceUpdate();
                    },
                });
            },
            async onTicketUpdate(ticket) {
                const proj_idx = this.projetos.findIndex(proj => proj.id_projeto == ticket.projeto_id);

                const mvp_idx = this.projetos[proj_idx].mvps.findIndex(mvp => mvp.id_ticket == ticket.id_ticket);

                if (mvp_idx >= 0) {
                    this.projetos[proj_idx].mvps.splice(mvp_idx, 1, ticket);
                } else {
                    let {data: projeto} = await this.$axios.get(`projeto/${ticket.projeto_id}`);

                    this.projetos[proj_idx].mvps = projeto.mvps.filter(mvp => mvp.ativo == 1)
                        .map(mvp => {
                            return mvp;
                        }).sort((a, b) => {
                            if (a.posicao > b.posicao) {
                                return 1;
                            }
                            if (a.posicao < b.posicao) {
                                return -1;
                            }
                            return 0;
                        });
                }
            },

            disableBrothersFilters(panelKeys, key){
                Object.keys(panelKeys).forEach(pk => pk == key ? this.filters[key] = !this.filters[key] : this.filters[pk] = false);
            },
            verifyWidth(windowWidth) {
                this.enableDrag = !this.iOS && windowWidth > 700;
                this.widthDrawer = windowWidth < 850 ? windowWidth : 850;
            },
            handleWindowResize: debounce(function (event) {
                this.verifyWidth(event.currentTarget.innerWidth);
            }, 400)
        },
        mounted() {
            this.iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent) && !window.MSStream;
            this.verifyWidth(window.innerWidth);
            this.$nextTick(() => {
                window.addEventListener('resize', this.handleWindowResize);
            });
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleWindowResize);
        },
    };
</script>

<style scoped>
    .transition {
        transition: font 0.2s ease-in;
    }
</style>

<style>
    .table-mvps .table-row .vs-button-danger {
        visibility: hidden;
    }

    .table-mvps .table-row:hover .vs-button-danger {
        visibility: visible;
    }
</style>
